export default __webpack_public_path__ + "static/media/avatar-1.59e4a96e.png";